import { IDictionary } from '../dictionary/IDictionary';
import { ITypedResponse } from '@caslink/common-client';
import { ICellularDeviceActivationService } from './icellular-device-activation.service';
import { ICellularDeviceActivationViewModel } from './icellular-device-activation.model';
import { Injectable } from '@angular/core';
import { ProxyService } from '../proxy/ProxyService';

@Injectable({
    providedIn: 'root'
})
export class CellularDeviceActivationService implements ICellularDeviceActivationService {
    public static $name: string = 'cellularDeviceActivationService';

    constructor(
        private proxyService: ProxyService
    ) {
    }

    public sendActivationRequest(viewModel: ICellularDeviceActivationViewModel) {
        return this.proxyService.request({
            data: viewModel,
            endPoint: 'cellularDeviceActivation',
            route: 'sendActivationRequest',
        }).as<ITypedResponse<string>>();
    }

    public validateIdentifiers(identifiers: IDictionary<string>, cellularVendorId: string, moduleId: number) {
        return this.proxyService.request({
            data: identifiers,
            endPoint: 'cellularDeviceActivation',
            route: 'validateDeviceIdentifiers',
            routeParams: {
                cellularVendorId: cellularVendorId,
                moduleId: moduleId
            }
        }).as<boolean>();
    }

    public updateCellularDeviceStatus(moduleId: number) {
        return this.proxyService.request({
            endPoint: 'cellularDeviceActivation',
            route: 'updateCellularDeviceStatus',
            routeParams: {
                moduleId: moduleId
            }
        }).as<CASLink.Device.Ui.ViewModel.Modules.CellularDeviceStatusViewModel>();
    }
}
